<template>
  <div>
    <vs-popup :title="$t('Attachments')" :active.sync="showModal">
      <div class="flex">
        <div class="w-full">
          <vx-card>
            <div class="upload-wrapper">
              <my-upload
                field="img"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                @src-file-set="srcFileSet"
                v-model="isAddPicture"
                :width="600"
                :height="600"
                langType="fa"
                :value.sync="isAddPicture"
                img-format="jpg"
              ></my-upload>
              <img :src="newPicture.imageContent" />
            </div>
            <a
              style="width: 200px;"
              class="img-box w-1/4"
              @click.prevent="toggleShow"
            >
              {{ $t("UploadImage")
              }}<i class="material-icons notranslate">
                cloud_upload
              </i>
            </a>
          </vx-card>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import myUpload from "vue-image-crop-upload";
import { mapActions } from "vuex";
import ImagePopup from "./ImagePopup.vue";
export default {
  props: {
    show: { default: false },
    packageId: { default: "" }
  },
  data() {
    return {
      actualGalleryDetails: {},
      newPicture: {},
      isAddPicture: false,
      imgDataUrl: "",
      editMode: false,
      ImagePopup: false,
      modal: {},
      imgName: ""
    };
  },
  components: {
    "my-upload": myUpload,
    ImagePopup
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  mounted() {
    this.toggleShow();
  },
  methods: {
    ...mapActions({
      deliveryToCustomer: "identityAccess/deliveryToCustomer"
    }),
    submitEdit(item, index) {
      this.updateActualGallery(item).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
          showConfirmButton: false,
          timer: 2000
        });
        this.$validator.reset();
        this.$set(this.actualGalleryDetails[index], "editMode", false);
      });
    },
    editAlt(row, index) {
      this.$set(this.actualGalleryDetails[index], "editMode", true);
    },
    cancelEdit(row, index) {
      this.$set(this.actualGalleryDetails[index], "editMode", false);
    },
    cropSuccess(imgDataUrl) {
      this.imageContent = imgDataUrl;
      this.newPicture = {
        alt: this.imgName,
        receiptImageContent: imgDataUrl,
        packageId: this.packageId
      };
      this.$emit("deliveryToCustomerWithReceipt", this.newPicture);
      this.$emit("finish");
    },
    cropUploadSuccess() {},
    srcFileSet(fileName) {
      this.imgName = fileName;
    },
    cropUploadFail() {},
    toggleShow() {
      this.isAddPicture = !this.isAddPicture;
    },
    imgPopup(model) {
      this.ImagePopup = true;
      this.modal = model.uri;
    },
    onfinish() {
      this.ImagePopup = false;
    }
  }
};
</script>
